import { defineStore } from 'pinia'
import { ref } from 'vue';
import { getPacsData, getPacsThumbnail, uploadPacsData, getPacsConfig, updatePacsConfig } from '../api';
import { useDicomStore } from './dicom';
import { usePageStore } from './pagenation';
import { usePopupStore } from './popup';
import moment from 'moment';

export interface PacsItem {
  AccessionNumber: string;
  BodyPartExamined: string;
  Modality: string;
  PatientID: string;
  PatientName: string;
  SOPInstanceUID: string;
  SeriesDescription: string;
  SeriesInstanceUID: string;
  StudyDate: string;
  StudyDescription: string;
  StudyInstanceUID: string;
  PatientAge: string;
  PatientSex: string;
  selected: boolean;
}

export interface PacsConfigInfo {
  title: string,
  ip: string,
  port: string
}

export const usePacsStore = defineStore('pacs', {
  state: () => ({
    pacsData: [] as PacsItem[],
    currPageData: [] as PacsItem[],
    selectedListCount: 0,
    uploadProgress: 0,
    config: {
      title: '',
      ip: '',
      port: ''
    } as PacsConfigInfo,
    connectState: true
  }),
  actions: {
    async searchPacsData(id: string, name: string, studyDate: string, page: number) {
      try {
        const res = await getPacsData(id, name, studyDate, page);
        this.pacsData = [];

        res.results.forEach((item: any) => {
          this.pacsData.push({
            ...item,
            selected: false
          });
        });

        let totalPages = 1;
        if (this.pacsData.length > 0) {
          totalPages = Math.ceil((this.pacsData.length) / 18)
        }
        usePageStore().setTotalPage(totalPages)
      } catch (err) {
        console.error('get PACS data failed:', err);
        usePageStore().setTotalPage(1)
      }
    },
    async getPacsConfig() {
      console.log('get pacs config');
      try {
        const res = await getPacsConfig();
        this.config.title = res.PACS_AET
        this.config.ip = res.PACS_IP
        this.config.port = res.PACS_PORT
        this.connectState = res.is_connected;
        return res.is_connected;
      } catch (err) {
        console.error('get PACS config failed:', err);
      }
    },
    setPacsConfigInfo(info: any) {
      this.config = info;
      this.updatePacsConfig();
    },
    initPacsConfigInfo() {
      this.config = {
        title: '',
        ip: '',
        port: ''
      } as PacsConfigInfo
    },
    async updatePacsConfig() {
      try {
        const res = await updatePacsConfig();
        
        if(res) {
          const today = new Date();
          await this.searchPacsData("", "", `${moment(today).format('YYYYMMDD')}-${moment(today).format('YYYYMMDD')}`, 1);
          usePopupStore().togglePopup('pacs', true);
        } else {
          usePopupStore().togglePopup('pacsSetting', true);
        }
        usePopupStore().togglePopup('nowConnect', false);
      } catch (err) {
        console.error('update PACS config failed:', err);
      }
    },
    async uploadPacsData() {
      try {
        const uploadRes = await uploadPacsData();
        if(uploadRes) {
          for (const data of this.pacsData) {
            data.selected = false;
          }
        }
        return uploadRes;
      } catch (err) {
        console.error('upload PACS data failed:', err);
      }
    },
    async getPacsThumbnail(uid: string) {
      try {
        const thumbnailUrl = await getPacsThumbnail(uid);
        return thumbnailUrl;
      } catch (err) {
        console.error('get PACS data failed:', err);
      }
    },
    setUploadProgress(percent: number) {
      this.uploadProgress += percent;
      if (this.uploadProgress >= 100) {
        setTimeout(() => {
          usePopupStore().togglePopup('nowLoading', false);
          this.initUploadProgress();
        }, 300);
      }
    },
    initUploadProgress() {
      this.uploadProgress = 0;
    },
    setConnectState(state: boolean) {
      this.connectState = state;
    },
    setCurrPageDate(data: PacsItem[]) {
      this.currPageData = data;
    }
  },
  getters: {
    getPacsData(state): any {
      return state.pacsData;
    },
    getSelectedCount(state): any {
      return state.selectedListCount;
    },
    getUploadProgress(state): number {
      return state.uploadProgress;
    },
    getPacsConfigInfo(state): any {
      return state.config;
    },
    getConnectState(state): boolean {
      return state.connectState;
    },
    getCurrPageData(state): PacsItem[] {
      return state.currPageData;
    }
  },
});